import type { AuthCookieStorageConfig } from "./auth-cookie-storage.ts";
import { createAuthCookieStorage } from "./auth-cookie-storage.ts";

function createD2cCustomerAuthCookieStorage(
	options: Omit<AuthCookieStorageConfig, "prefix" | "expiresInDays">,
) {
	return createAuthCookieStorage({
		prefix: "bm",
		expiresInDays: 93,
		...options,
	});
}

export { createD2cCustomerAuthCookieStorage };
